import { Provider } from 'react-redux'
import { store } from '~/Store'
import SequencedFormContainer from './SequencedFormContainer'
import { SequencedFormDataProvider } from './SequencedFormDataProvider'

export default SequencedForm = (props) ->

  <Provider store={ store }>
    <SequencedFormDataProvider>
      <SequencedFormContainer { props... } />
    </SequencedFormDataProvider>
  </Provider>
